import React from 'react'
import glamorous from 'glamorous'

const PageContent = glamorous.div(
  {
    padding: 20,
  }
)

PageContent.propTypes = {}
PageContent.defaultProps = {}

export default PageContent



// WEBPACK FOOTER //
// ./src/components/wrappers/PageContent.js